import BaseController from "./BaseController";
import "reflect-metadata";
import { RegisterServices } from "../di/container"; // Keep the import for dependency injection
import JSONModel from "sap/ui/model/json/JSONModel";
import { EnvironmentConfig } from "../util/environmentConfig";

RegisterServices(); // Register services in the DI container

/**
 * @namespace ang.order_portal.controller
 */
export default class App extends BaseController {
	public onInit() {
		// apply content density mode to root view
		this.getView().addStyleClass(
			this.getOwnerComponent().getContentDensityClass(),
		);

		const logoUrl = EnvironmentConfig.getLogoUrl();

		void this.getText("appTitle").then((appTitle) => {
			this.getView().setModel(new JSONModel({ logoUrl, appTitle }), "res");
			document.title = appTitle;
		});

		const uiModel = new JSONModel({
			showAuthHeader: true,
			showShellChrome: false,
		});
		this.getView().setModel(uiModel, "ui");

		this.getRouter().attachRouteMatched((event: any) => {
			const isAuthRoute = event.getParameter("name") === "auth";
			uiModel.setProperty("/showAuthHeader", isAuthRoute);
			uiModel.setProperty("/showShellChrome", !isAuthRoute);
		});
	}

	public onOpenImpressum(): void {
		this.getRouter().navTo("impressum");
	}

	public onOpenDatenschutz(): void {
		this.getRouter().navTo("datenschutz");
	}
}
